import React from 'react';
import Testimonials from '../components/sections/Testimonials';
import PageHeader from '../components/ui/PageHeader';
import './StaticPage.css';

const TestimonialsPage: React.FC = () => (
  <div className="static-page">
    <PageHeader page="testimonials" />
    <Testimonials />
  </div>
);

export default TestimonialsPage;
